import { render, staticRenderFns } from "./MasterQuestionType.vue?vue&type=template&id=00f6fa70&scoped=true"
import script from "./MasterQuestionType.vue?vue&type=script&lang=js"
export * from "./MasterQuestionType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f6fa70",
  null
  
)

export default component.exports